const downloadFile = ({ data, fileName, remoteUrl = null, format = 'pdf' }) => {
  const dataType = format === 'pdf' ? 'application/pdf' : 'text/plain';

  const url = remoteUrl || window.URL.createObjectURL(new Blob([data], { type: dataType }));
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.target = '_blank';
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export default downloadFile;
